unit View.Facil_Planos_Aliados.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewFacil_Planos_AliadosList = class(TForm)
    btNew: TButton;
    Facil_Planos_AliadosDataset: TXDataWebDataSet;
    Facil_Planos_AliadosDatasetid: TIntegerField;
    Facil_Planos_AliadosDatasetfacil_planos_id: TIntegerField;
    Facil_Planos_AliadosDatasetaliado_id: TIntegerField;
    Facil_Planos_AliadosDatasetdata_inicio: TDateTimeField;
    Facil_Planos_AliadosDatasetdata_fim: TDateTimeField;
    Facil_Planos_AliadosDatasetplano_ativo: TBooleanField;
    Facil_Planos_AliadosDatasetexcluido: TBooleanField;
    Facil_Planos_AliadosDatasetinclusao: TDateTimeField;
    Facil_Planos_AliadosDatasetalteracao: TDateTimeField;
    Facil_Planos_AliadosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewFacil_Planos_AliadosList: TFViewFacil_Planos_AliadosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFacil_Planos_AliadosList }

procedure TFViewFacil_Planos_AliadosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewFacil_Planos_AliadosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFacil_Planos_AliadosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewFacil_Planos_AliadosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewFacil_Planos_AliadosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewFacil_Planos_AliadosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewFacil_Planos_AliadosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Facil_Planos_AliadosDataset.Connection.Model.DefaultSchema.FindEntityType(Facil_Planos_AliadosDataset.EntitySetName),
      Facil_Planos_AliadosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewFacil_Planos_AliadosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('facil_planos_aliados', 'active');
  TUtils.SetValorDicionarioClasses('facil_planos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_facil_planos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Facil_Planos_AliadosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewFacil_Planos_AliadosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.facil_planos_aliados.list.pagination.info');
  btNew := TButton.Create('view.facil_planos_aliados.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.facil_planos_aliados.list.table');
  cbPageSize := TComboBox.Create('view.facil_planos_aliados.list.cbPageSize');
  edSearch := TEdit.Create('view.facil_planos_aliados.list.search');
  lcPaginator := TListControl.Create('view.facil_planos_aliados.list.pagination');
  Facil_Planos_AliadosDataset := TXDataWebDataSet.Create(Self);
  Facil_Planos_AliadosDatasetid := TIntegerField.Create(Self);
  Facil_Planos_AliadosDatasetfacil_planos_id := TIntegerField.Create(Self);
  Facil_Planos_AliadosDatasetaliado_id := TIntegerField.Create(Self);
  Facil_Planos_AliadosDatasetdata_inicio := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetdata_fim := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetplano_ativo := TBooleanField.Create(Self);
  Facil_Planos_AliadosDatasetexcluido := TBooleanField.Create(Self);
  Facil_Planos_AliadosDatasetinclusao := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetalteracao := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Facil_Planos_AliadosDataset.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetid.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetfacil_planos_id.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetaliado_id.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetdata_inicio.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetdata_fim.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetplano_ativo.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetexcluido.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetinclusao.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetalteracao.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewFacil_Planos_AliadosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'facil_planos_id';
      Title := 'facil_planos_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_inicio';
      Title := 'data_inicio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_fim';
      Title := 'data_fim';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_ativo';
      Title := 'plano_ativo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Facil_Planos_AliadosDataset.SetParentComponent(Self);
    Facil_Planos_AliadosDataset.Name := 'Facil_Planos_AliadosDataset';
    Facil_Planos_AliadosDataset.EntitySetName := 'Facil_Planos_Aliados';
    Facil_Planos_AliadosDataset.Connection := DMConnection.ApiConnection;
    Facil_Planos_AliadosDataset.Left := 72;
    Facil_Planos_AliadosDataset.Top := 144;
    Facil_Planos_AliadosDatasetid.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetid.Name := 'Facil_Planos_AliadosDatasetid';
    Facil_Planos_AliadosDatasetid.FieldName := 'id';
    Facil_Planos_AliadosDatasetid.Required := True;
    Facil_Planos_AliadosDatasetfacil_planos_id.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetfacil_planos_id.Name := 'Facil_Planos_AliadosDatasetfacil_planos_id';
    Facil_Planos_AliadosDatasetfacil_planos_id.FieldName := 'facil_planos_id';
    Facil_Planos_AliadosDatasetfacil_planos_id.Required := True;
    Facil_Planos_AliadosDatasetaliado_id.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetaliado_id.Name := 'Facil_Planos_AliadosDatasetaliado_id';
    Facil_Planos_AliadosDatasetaliado_id.FieldName := 'aliado_id';
    Facil_Planos_AliadosDatasetaliado_id.Required := True;
    Facil_Planos_AliadosDatasetdata_inicio.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetdata_inicio.Name := 'Facil_Planos_AliadosDatasetdata_inicio';
    Facil_Planos_AliadosDatasetdata_inicio.FieldName := 'data_inicio';
    Facil_Planos_AliadosDatasetdata_fim.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetdata_fim.Name := 'Facil_Planos_AliadosDatasetdata_fim';
    Facil_Planos_AliadosDatasetdata_fim.FieldName := 'data_fim';
    Facil_Planos_AliadosDatasetplano_ativo.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetplano_ativo.Name := 'Facil_Planos_AliadosDatasetplano_ativo';
    Facil_Planos_AliadosDatasetplano_ativo.FieldName := 'plano_ativo';
    Facil_Planos_AliadosDatasetplano_ativo.Required := True;
    Facil_Planos_AliadosDatasetexcluido.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetexcluido.Name := 'Facil_Planos_AliadosDatasetexcluido';
    Facil_Planos_AliadosDatasetexcluido.FieldName := 'excluido';
    Facil_Planos_AliadosDatasetinclusao.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetinclusao.Name := 'Facil_Planos_AliadosDatasetinclusao';
    Facil_Planos_AliadosDatasetinclusao.FieldName := 'inclusao';
    Facil_Planos_AliadosDatasetalteracao.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetalteracao.Name := 'Facil_Planos_AliadosDatasetalteracao';
    Facil_Planos_AliadosDatasetalteracao.FieldName := 'alteracao';
    Facil_Planos_AliadosDatasetexclusao.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetexclusao.Name := 'Facil_Planos_AliadosDatasetexclusao';
    Facil_Planos_AliadosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Facil_Planos_AliadosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Facil_Planos_AliadosDataset.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetid.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetfacil_planos_id.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetaliado_id.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetdata_inicio.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetdata_fim.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetplano_ativo.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetexcluido.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetinclusao.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetalteracao.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
